import { faExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function ResetPassword({ open, setOpen , postResetPassword, resetLoading}) {
    const navigate = useNavigate();

    return (

        <Dialog
            open={open}
            // onClose={() => setOpen(false)}
            fullWidth
            maxWidth='sm'
        >
            <DialogContent>
                {resetLoading ? <div style={{display: 'flex', alignItems: "center", justifyContent:'center', height:'400px'}}>
                    <CircularProgress size={100}/>
                </div> :
                <>
                
                <div style={{ display: 'flex', alignItems: "center", flexDirection: 'column', width: '100%', paddingBottom: '1rem' }}>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', width: 80, height: 80, background: '#4AB866', marginBottom: "20px", borderRadius: '50%' }}>
                        <FontAwesomeIcon icon={faExclamation} style={{
                            color: '#ffff',
                            fontSize: '2.3rem'
                        }} />
                    </div>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: 'bold',
                            color: '#4AB866'
                        }}>
                            ต้องการเปลี่ยนรหัสผ่าน หรือไม่
                        </label>
                    </div>
                </div>

                <hr />
                <div class="row mt-4">

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button variant='outlined' sx={{ width: '120px', marginRight: '10px' }} onClick={() => setOpen(false)}> ปิด</Button>

                        <Button variant='contained' sx={{ width: '130px' }} onClick={() => {
                            postResetPassword()
                        }}>ยืนยัน</Button>
                    </div >
                </div >
                </>}
            </DialogContent >
        </Dialog >

    )
}
